import { useCallback, useRef } from 'react';
import { useState } from 'react';
import { safeParseJSONNotRef } from '../utils/jsonValidator';
import { resolveConfig } from '../helpers/configResolver';

export function useResolveBodyData(body_data = {}) {
    const [bodyData, setbodyData] = useState(() => safeParseJSONNotRef(body_data));
    const initialRef = useRef(safeParseJSONNotRef(body_data));

    const setBodyData = useCallback((newData) => {
        const parsed = safeParseJSONNotRef(newData);
        setbodyData(parsed);
        initialRef.current = parsed;
    }, []);

    const processVariables = (body, values) => {
        if (!body?.variables) return body;
        let variables = JSON.stringify(body.variables);

        for (let key in values) {
            let value = String(values[key] || '')
                .replace(/"/g, '\\"')
                .replace(/[\r\n]+/g, ' ');

            if (value === `{${key}}`) value = '';

            variables = variables.toString()
                .replace(`{${key}}`, value)
                .replace(`{[form].${key}}`, value);
        }

        return { ...body, variables };
    };

    // const resolveInfo = useCallback((values, key = null) => {
    //     const resolved = resolveConfig(bodyData, values, {}, key);
    //     const finalObj = processVariables(resolved, values);
    //     setbodyData(finalObj);
    //     return finalObj;
    // }, [bodyData]);

    const resolveInfo = useCallback((values, key = null, fromScratch = false) => {
        const baseData = fromScratch ? initialRef.current : bodyData;

        const resolved = resolveConfig(baseData, values, {}, key);
        const finalObj = processVariables(resolved, values);

        setbodyData(finalObj);
        return finalObj;
    }, [bodyData]);


    // const resetInit = useCallback(() => {
    //     setbodyData(safeParseJSONNotRef(initialRef.current));
    // }, []);
    const resetInit = useCallback(() => {
        setbodyData(initialRef.current);
    }, []);

    return { bodyData, resolveInfo, resetInit, setBodyData };
}
